import { Autocomplete, Button, Card, CardContent, Checkbox, Collapse, Dialog, DialogActions, DialogContent, FormControlLabel, Grid, IconButton, TextField, Tooltip, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import { OpcionesMenuFunc } from '../../utils/componentes-utiles/OpcionesMenuFunc';
import React, { useEffect, useState, useContext, forwardRef } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import { updateProyecto } from '../../services/apis';
import { useTheme } from '@mui/material/styles';
import { VariableSizeList } from 'react-window';

const LISTBOX_PADDING = 8;
const OuterElementContext = React.createContext({});
const OuterElementType = forwardRef((props, ref) => {
    const outerProps = useContext(OuterElementContext);
    return <div ref={ref} {...props} {...outerProps} />;
});
function renderRow(props) {
    const { data, index, style } = props;
    return React.cloneElement(data[index], {
        style: {
            ...style,
            top: style.top + LISTBOX_PADDING,
        },
    });
}

function ListboxComponent(props) {
    const { children, ...other } = props;
    const itemData = [];

    children.forEach((item) => {
        itemData.push(item);
    });

    const theme = useTheme();
    const itemSize = 48;

    const getChildSize = () => itemSize;
    const getHeight = () => {
        return Math.min(8, itemData.length) * itemSize + 2 * LISTBOX_PADDING;
    };

    return (
        <div>
            <OuterElementContext.Provider value={other}>
                <VariableSizeList
                    itemData={itemData}
                    height={getHeight()}
                    width="100%"
                    outerElementType={OuterElementType}
                    innerElementType="ul"
                    itemSize={getChildSize}
                    overscanCount={5}
                    itemCount={itemData.length}
                >
                    {renderRow}
                </VariableSizeList>
            </OuterElementContext.Provider>
        </div>
    );
}

export const ProyectoCard = ({ data, openEdit, opciones, cargarOpciones, cargarOpcionesAdm, clientes }) => {
    // Estados locales
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [nombre, setNombre] = useState(data.nombre);
    const [descripcion, setDescripcion] = useState(data.descripcion);
    const [alto, setAlto] = useState(0)
    const [clienteSelect, setClienteSelect] = useState(data.id_cliente);
    const [mostrarCliente, setMostrarCliente] = useState(false);

    // Global
    const navigate = useNavigate();
    // Función para convertir minutos en formato hh:mm
    const formatTime = (totalMinutes) => {
        if (totalMinutes === null || totalMinutes === undefined) return ""; // Si no hay minutos, devuelve vacío
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    };

    const handleOpen = (opcionId) => {

        switch (opcionId) {
            case 1:
                // Opción para editar el proyecto
                setOpen(true);
                break;
            case 2:
                // Opción para ocultar el proyecto
                setOpen2(true);
                break;
            default:
                break;
        }
    }

    const handleClose = () => {
        setOpen(false);
        setAlto(0)
    };

    const handleClose2 = () => {
        setOpen2(false);
    };

    const handledOnChange = (e) => {
        const { name, value } = e.target;

        switch (name) {
            case "nombre":
                setNombre(value); // Asumiendo que 'data' es un objeto que contiene los datos del proyecto
                break;
            case "descripcion":
                setDescripcion(value) // Asumiendo que 'data' es un objeto que contiene los datos del proyecto
                break;
            default:
                break
        }
    }

    const actualizarPy = async (data) => {
        console.log("Datos a actualizar:", data);
        data.nombre = nombre; // Actualiza el nombre en el objeto data
        data.descripcion = descripcion; // Actualiza la descripción en el objeto data
        data.id_cliente = clienteSelect.id;
        data.mostrarCliente = mostrarCliente;
        try {
            const response = await updateProyecto(data);

            if (response.success) {
                openEdit ? cargarOpciones(1) : cargarOpciones(0);
                cargarOpcionesAdm();
                setOpen(false);
                setOpen2(false);
            }

        } catch (error) {
            console.error("Error:", error);
        }
    }

    const ocultarProyect = (data) => {
        data.oculto == 1
            ? data.oculto = 0
            : data.oculto = 1; // Cambia el estado de oculto

        actualizarPy(data);
    }

    const encontrarCliente = () => {
        const clienteEncontrado = clientes.find(c => c.id === data.id_cliente);
        if (clienteEncontrado) {
            setClienteSelect(clienteEncontrado);
        }
    }
    useEffect(() => {
        encontrarCliente();
    }, [clientes, data.id_cliente]);


    return (
        <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            xs={12} sm={6} md={4} lg={2.5}
            className="menu-card"
            style={{ cursor: 'pointer', transition: '0.3s', borderRadius: 15, boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.4)', background: data.oculto == 1 ? "#aaaaaa" : '#FFF', padding: 10 }}
        >
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                xs={12}
                onClick={() => navigate("/proyecto/" + data.id)}
            >
                <IconButton color='primary'>
                    <FolderSpecialIcon />
                </IconButton>
                <Typography variant="h6" component="div">
                    {data.nombre.toUpperCase()}
                </Typography>
                <Typography variant="h6" component="div">
                    {formatTime(data.total_minutos) + "H"}
                </Typography>
            </Grid>

            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                xs={10} sm={10} lg={12}
            >
                <Collapse in={openEdit} sx={{ width: '100%' }}>
                    <OpcionesMenuFunc opciones={opciones} handleEvent={handleOpen} small={true} />
                </Collapse>
            </Grid>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth="md"
            >
                <DialogContent>
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="start"
                        xs={12}
                    >
                        <Grid item xs={10}>
                            <Typography variant="h5" component="div" sx={{ mb: 2 }}>
                                ¿Qué quieres hacer con el proyecto {data.nombre}?
                            </Typography>
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton onClick={handleClose} color="primary">
                                <ClearIcon />
                            </IconButton>
                        </Grid>

                    </Grid>

                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        xs={12}
                        gap={2}
                    >
                        <Grid item xs={12}>
                            <TextField id="outlined-basic" label="Nombre del proyecto" variant="outlined" name='nombre' value={nombre} onChange={handledOnChange} fullWidth />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField id="outlined-basic" label="Descripción del proyecto" variant="outlined" name='descripcion' value={descripcion} onChange={handledOnChange} fullWidth multiline rows={4} />
                        </Grid>

                        <Grid item xs={12}>
                            <Tooltip
                                arrow
                                title={
                                    <Typography variant='subtitle1' sx={{ p: 1 }}>
                                        ¡¡¡ATENCION!!!
                                        Si desmarcas este campo el admin cliente podra ver este proyecto
                                    </Typography>
                                }
                            >
                                <FormControlLabel control={<Checkbox checked={mostrarCliente} value={mostrarCliente} onChange={() => setMostrarCliente(mostrarCliente ? false : true)} />} label="Ocultar proyecto al cliente asignado" />
                            </Tooltip>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        direction="column"
                        justifyContent="start"
                        alignItems="start"
                        xs={12}
                        sx={{ minHeight: alto, transition: 'all 0.35s ease', mt: 2 }}
                    // onClick={() => alto === 650 ? setAlto(200) : setAlto(650)}
                    >
                        <Autocomplete
                            disablePortal
                            options={clientes}
                            value={clienteSelect || null}
                            // defaultValue={idGestwin || null}
                            getOptionLabel={(option) => option.nombre}
                            ListboxComponent={ListboxComponent}
                            onChange={(event, newValue) => { setClienteSelect(newValue); setAlto(0); console.log("AAAAAAAAAAAAAAAAAAAAAAAAAA", newValue); }}
                            renderInput={(params) => <TextField {...params} label="Cliente asignado" />}
                            fullWidth
                            onFocus={() => setAlto(450)}
                            onFocusCapture={() => setAlto(450)}
                            onBlur={() => setAlto(0)}
                            onClose={() => setAlto(0)}
                            onOpen={() => setAlto(450)}
                        />
                    </Grid>


                </DialogContent>

                <DialogActions>
                    <Button variant='outlined' color='primary' onClick={handleClose}>
                        Cerrar
                    </Button>

                    <Button variant='contained' color='primary'
                        onClick={() => {
                            actualizarPy(data)
                        }}
                    >
                        Editar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open2}
                onClose={handleClose2}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth="md"
            >
                <DialogContent>
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="start"
                        xs={12}
                    >
                        <Grid item xs={10}>
                            <Typography variant="h5" sx={{ mb: 2 }}>
                                ¿Desea {data.oculto == 1 ? 'mostrar' : 'ocultar'} {data.nombre}?
                            </Typography>
                        </Grid>

                        <IconButton onClick={handleClose2} color="primary">
                            <ClearIcon />
                        </IconButton>

                    </Grid>

                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        xs={12}
                        gap={2}
                    >
                        {
                            data.oculto == 1 ? (
                                <Grid item xs={12}>
                                    <Typography variant="body1">
                                        Este proyecto ya está oculto. Desea mostrarlo de nuevo?
                                    </Typography>
                                </Grid>
                            ) : (
                                <Grid item xs={12}>
                                    <Typography variant="body1">
                                        Si ocultas este proyecto, no aparecerá en la lista de proyectos activos, pero no se eliminará.
                                    </Typography>
                                </Grid>
                            )
                        }

                    </Grid>

                </DialogContent>

                <DialogActions>
                    <Button variant='outlined' color='primary' onClick={handleClose2}>
                        Cerrar
                    </Button>

                    <Button variant='contained' color='primary' onClick={() => {
                        ocultarProyect(data);
                    }}>
                        {
                            data.oculto == 1 ? "Mostrar Proyecto" : "Ocultar Proyecto"
                        }
                    </Button>
                </DialogActions>
            </Dialog>

        </Grid>

    )
}
